"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRealState = exports.isOlxPay = exports.isFirstChat = exports.isChatValidToUploadImage = exports.isAuto = exports.getSellerId = exports.getRoomnameKeysWithActiveStatus = exports.getPartner = exports.getOrderedChatsByLastMessage = exports.getOldestChat = exports.getNextCurrentChat = exports.getCurrentUser = exports.getCurrentRoomname = exports.getCurrentChatPosition = exports.getCurrentChat = exports.getChatId = exports.getChatByRoomName = exports.getCategory = exports.getBuyerId = exports.getButtons = exports.amISeller = exports.alreadyLoadedChats = void 0;
var _reselect = require("reselect");
var _chatUtil = require("../helpers/chatUtil");
var _adUtil = require("../helpers/adUtil");
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// ====================================================================
// Select data from * state *
// ====================================================================

var _getChatsByRoomName = function _getChatsByRoomName(_ref) {
  var chatsByRoomName = _ref.chatsByRoomName;
  return chatsByRoomName;
};
var _getCurrentRoomname = function _getCurrentRoomname(_ref2) {
  var currentChat = _ref2.currentChat;
  return currentChat;
};
var _getCurrentChatPosition = function _getCurrentChatPosition(_ref3) {
  var currentChatPosition = _ref3.currentChatPosition;
  return currentChatPosition;
};
var _getChats = function _getChats(_ref4) {
  var chatsByRoomName = _ref4.chatsByRoomName;
  return Object.keys(chatsByRoomName).map(function (key) {
    return chatsByRoomName[key];
  });
};
var _chatsLoaded = function _chatsLoaded(_ref5) {
  var chatsLoaded = _ref5.chatsLoaded;
  return chatsLoaded;
};
var getRoomnameKeysWithActiveStatus = exports.getRoomnameKeysWithActiveStatus = function getRoomnameKeysWithActiveStatus(_ref6) {
  var chatsByRoomName = _ref6.chatsByRoomName;
  return Object.entries(chatsByRoomName).filter(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
      roomname = _ref8[0],
      data = _ref8[1];
    return data.adStatus === 'active' && roomname !== '1';
  }).map(function (_ref9) {
    var _ref10 = _slicedToArray(_ref9, 2),
      roomname = _ref10[0],
      _ = _ref10[1];
    return roomname;
  });
};

// ====================================================================
// Selectors
// ====================================================================

var getChatByRoomName = exports.getChatByRoomName = function getChatByRoomName(state, roomname) {
  return _getChatsByRoomName(state)[roomname];
};
var getCurrentChat = exports.getCurrentChat = (0, _reselect.createSelector)([_getCurrentRoomname, _getChatsByRoomName], function (currentRoomname, chatsByRoomName) {
  return chatsByRoomName[currentRoomname] || {};
});
var getButtons = exports.getButtons = (0, _reselect.createSelector)(getCurrentChat, function (_ref11) {
  var buttons = _ref11.buttons;
  return buttons;
});
var isOlxPay = exports.isOlxPay = (0, _reselect.createSelector)(getCurrentChat, function (_ref12) {
  var olxPay = _ref12.olxPay;
  return olxPay === '1';
});
var getCurrentRoomname = exports.getCurrentRoomname = (0, _reselect.createSelector)([_getCurrentRoomname], function (currentRoomname) {
  return currentRoomname;
});
var getCurrentChatPosition = exports.getCurrentChatPosition = (0, _reselect.createSelector)([_getCurrentChatPosition], function (currentChatPosition) {
  return currentChatPosition;
});
var getSellerId = exports.getSellerId = (0, _reselect.createSelector)(getCurrentChat, function (_ref13) {
  var sellerId = _ref13.sellerId;
  return sellerId;
});
var getBuyerId = exports.getBuyerId = (0, _reselect.createSelector)(getCurrentChat, function (_ref14) {
  var buyerId = _ref14.buyerId;
  return buyerId;
});
var amISeller = exports.amISeller = (0, _reselect.createSelector)(getCurrentChat, function (_ref15) {
  var myId = _ref15.username,
    sellerId = _ref15.sellerId;
  return myId === sellerId;
});
var getCurrentUser = exports.getCurrentUser = (0, _reselect.createSelector)(getCurrentChat, function (_ref16) {
  var username = _ref16.username;
  return username;
});
var getCategory = exports.getCategory = (0, _reselect.createSelector)(getCurrentChat, function (_ref17) {
  var _ref17$category = _ref17.category,
    category = _ref17$category === void 0 ? 0 : _ref17$category;
  return parseInt(category, 10);
});
var isAuto = exports.isAuto = (0, _reselect.createSelector)(getCategory, function (category) {
  return category >= 2000 && category <= 2099;
});
var isRealState = exports.isRealState = (0, _reselect.createSelector)(getCategory, function (category) {
  return category >= 1000 && category <= 1200;
});
var getOrderedChatsByLastMessage = exports.getOrderedChatsByLastMessage = (0, _reselect.createSelector)(_getChats, function (chats) {
  return (0, _chatUtil.sortByLastMessageAndStatus)(chats);
});
var getOldestChat = exports.getOldestChat = (0, _reselect.createSelector)(_getChats, function (chats) {
  var orderedChats = (0, _chatUtil.sortByLastMessage)(chats);
  return orderedChats[orderedChats.length - 1];
});
var getNextCurrentChat = exports.getNextCurrentChat = (0, _reselect.createSelector)(getOrderedChatsByLastMessage, _getCurrentRoomname, function (chats, currentRoomname) {
  return (0, _chatUtil.getNextChat)(chats, currentRoomname);
});
var getPartner = exports.getPartner = (0, _reselect.createSelector)(getCurrentChat, function (_ref18) {
  var myId = _ref18.username,
    sellerId = _ref18.sellerId,
    buyerId = _ref18.buyerId;
  return myId === sellerId ? buyerId : sellerId;
});
var getChatId = exports.getChatId = (0, _reselect.createSelector)(getCurrentChat, function (_ref19) {
  var listId = _ref19.listId,
    sellerId = _ref19.sellerId,
    buyerId = _ref19.buyerId;
  return "".concat(listId, "-").concat(sellerId, "-").concat(buyerId);
});
var alreadyLoadedChats = exports.alreadyLoadedChats = (0, _reselect.createSelector)(_chatsLoaded, function (chatsLoaded) {
  return chatsLoaded;
});
var isChatValidToUploadImage = exports.isChatValidToUploadImage = (0, _reselect.createSelector)([getCurrentChat], function (chat) {
  var category = chat.category;
  return (0, _adUtil.isCategoryValidToUploadImage)(category);
});
var isFirstChat = exports.isFirstChat = (0, _reselect.createSelector)([_getCurrentRoomname, _getChatsByRoomName], function (chatsByRoomName) {
  return chatsByRoomName.length === 1;
});